import { Store, Truck, Users, Wallet } from "lucide-react";
import { motion } from "framer-motion";

const steps = [
  {
    icon: Store,
    title: "Browse Local Stores",
    description: "Discover stores in your neighborhood with fresh products and great deals.",
  },
  {
    icon: Wallet,
    title: "Place Your Order",
    description: "Add items to cart, select nearest store, and checkout securely.",
  },
  {
    icon: Truck,
    title: "Fast Delivery",
    description: "Get your order delivered to your doorstep in 15-30 minutes.",
  },
  {
    icon: Users,
    title: "Earn Referral Income",
    description: "Share your referral link and earn commissions on every purchase.",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-14 bg-gradient-warm">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold mb-2">How It Works</h2>
          <p className="text-muted-foreground text-sm">Simple, fast, and rewarding</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1, duration: 0.4 }}
              className="relative text-center p-6 rounded-2xl bg-card border border-border/50 hover:shadow-md transition-all duration-300"
            >
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center">
                {i + 1}
              </div>
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4 mt-2">
                <step.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-heading font-bold text-base mb-2">{step.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
